import React from 'react';
import styles from './Profile.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import axios from 'axios';
import { Layout } from 'antd';
import { User } from "react-feather";
import {PhoneOutlined, MailOutlined, HomeOutlined, GlobalOutlined,
    LinkedinFilled, GithubFilled, TwitterCircleFilled, EditFilled,
    FacebookFilled, InstagramFilled, DeleteFilled
} from '@ant-design/icons';
import { SERVER_ROUTE } from '../Config.js'
import { Button, Modal, Space } from 'antd';
import { DatePicker, Checkbox } from 'antd';
import dayjs from 'dayjs';

const siderStyle = {
    overflow: 'auto',
    height: '92vh',
    position: 'sticky',
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: 'thin',
    scrollbarGutter: 'stable',
    padding: '10px',
    backgroundColor: '#eee',
    borderRight: '1px solid #ccc',
};

const formContent = {
    name: "",
    email: "",
    phone: "",
    address: "",
    links: [],
    languages: [],
    college: "",
    degree: "",
    startDate: "",
    endDate: "",
    result: "",
    category: "",
    current: false,
    items: [],
    currentItem: "",
    currentLink: "",
    currentLanguage: "",
    company: "",
    position: "",
    location: "",
    description: "",
    techstack: "",
    title: {
        education: "Add New Education",
        experience: "Add New Experience",
        projects: "Add New Project",
        skills: "Add New Skills",
        courses: "Add New Courses",
        achievements: "Add New Achievements",
        por: "Add New Projects/Responsibilities",
        basicInfo: "Edit Profile",
    },
}

const Profile = (props) => {
    const [profile, setProfile] = useState({
        name: "",
        email: "",
        phone: "",
        address: "",
        links:[],
        languages:[],
        education:[],
        skills:[],
        projects:[],
        experience:[],
        courses:[],
        achievements:[],
        por:[],
    });
    const [content, setContent] = useState(formContent);
    const [section, setSection] = useState('education');
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [editIndex, setEditIndex] = useState('');



    const showModal = () => {
        setOpen(true);
    };

    const getItem = (section) => {
        if (section === "basicInfo") {
            return {
                name: content.name,
                email: content.email,
                phone: content.phone,
                address: content.address,
                links: content.links,
                languages: content.languages,
            };
        }else if(section === "education") {
            return {
                college: content.college,
                degree: content.degree,
                startDate: content.startDate,
                endDate: content.endDate,
                result: content.result,
                current: content.current,
            }
        }else if(section === "experience") {
            return {
                company: content.company,
                position: content.position,
                startDate: content.startDate,
                endDate: content.endDate,
                location: content.location,
                description: content.description,
                current: content.current,
            }
        }else if(section === "projects") {
            return {
                name: content.name,
                techstack: content.techstack,
                startDate: content.startDate,
                endDate: content.endDate,
                description: content.description,
                current: content.current,
            }
        }else if(section === "skills") {
            return {
                category: content.category,
                items: content.items,
            }
        }else{
            return content.items;
        }
    }

    const getUpdatedData = (section, updatedData, index) => {
        if(section === "education" || section === "experience" || section === "projects" || section === "skills") {
            if(index === -1){
                return [...profile[section], updatedData];
            }else{
                const updatedSection = [...profile[section]];
                updatedSection[index] = updatedData;
                return updatedSection;
            }
        }else{
            if(index === -1){
                return [...profile[section], ...updatedData];
            }else{
                return updatedData;
            }
        }
    }

    const handleSave = (section, index) => {
        setConfirmLoading(true);
        const editedItem = getItem(section);
        console.log("Edited item: ", editedItem);
        const updatedData = getUpdatedData(section, editedItem, index);
        console.log("Updated data: ", updatedData);

        const success = updateProfile(section, updatedData);
        if (!success) {
            alert("Failed to update profile data");
            setConfirmLoading(false);
            return;
        }

        setProfile({
            ...profile,
            [section]: [...updatedData],
        });

        setConfirmLoading(false);
        setContent(formContent);
        setEditIndex('');
    }
    
    const handleOk = async () => {
        setConfirmLoading(true);
        const addedItem = getItem(section);
        console.log("Added item: ", addedItem);
        var updatedData = section === 'basicInfo' ? addedItem : getUpdatedData(section, addedItem, -1);
        console.log("Updated data: ", updatedData);
        const success = await updateProfile(section, updatedData);
        if (!success) {
            alert("Failed to update profile data");
            return;
        }
        if(section === 'basicInfo') {
            setProfile({
                ...profile,
                name: content.name,
                email: content.email,
                phone: content.phone,
                address: content.address,
                links: content.links,
                languages: content.languages,
            });
        }else{
            setProfile({
                ...profile,
                [section]: [...updatedData],
            });
        }

        setContent(formContent);
        setConfirmLoading(false);
        setSection("");
        setOpen(false);
    };

    const handleDelete = (section, index) =>{
        const updatedData = profile[section].filter((_, i) => i !== index);
        const success = updateProfile(section, updatedData);
        if (!success) {
            alert("Failed to update profile data");
            return;
        }
        setProfile({
            ...profile,
            [section]: updatedData,
        });
    }

    const updateProfile = async (section, updatedData) => {
        try {
            const response = await axios.post(`${SERVER_ROUTE}/api/profile/updateProfile`, {
                userId: props.user?.userData?._id,
                section: section,
                content: updatedData,
            }, { withCredentials: true });
            if (response.data.success) {
                console.log("Profile updated successfully");
                return true;
            } else {
                alert("Failed to update profile data");
                return false;
            }
        } catch (error) {
            console.error("Error updating profile data:", error);
            return false;
        }
    }

    const handleCancel = () => {
        setSection("");
        setContent(formContent);
        setOpen(false);
    };

    const handleAddItem = (section) => {
        setSection(section);
        showModal();
    }

    const linkIcon = {
        linkedInd: <LinkedinFilled className={styles.icon}/>,
        github: <GithubFilled className={styles.icon}/>,
        twitter: <TwitterCircleFilled className={styles.icon}/>,
        facebook: <FacebookFilled className={styles.icon}/>,
        instagram: <InstagramFilled className={styles.icon}/>,
        other: <GlobalOutlined className={styles.icon}/>,
    }

    const linkType = (link) => {
        if (link.includes("linkedin.com")) return "linkedInd";
        else if (link.includes("github.com")) return "github";
        else if (link.includes("twitter.com")) return "twitter";
        else if (link.includes("facebook.com")) return "facebook";
        else if (link.includes("instagram.com")) return "instagram";
        else return "other";
    }

    const getUserName = (link) => {
        const url = new URL(link);
        if (url.pathname !== "/") {
            const pathParts = url.pathname.split('/');
            return pathParts[pathParts.length - 1] || pathParts[pathParts.length - 2];
        }
        return url.hostname.replace('www.', '');
    }

    const inputForm = {
        education: (
            <div className={styles.inputForm}>
                <label htmlFor="college">College</label>
                <input type="text" id="college" placeholder="Enter college name" required
                        onChange={(e) => setContent({ ...content, college: e.target.value })} 
                />
                <label htmlFor="degree">Degree</label>
                <input type="text" id="degree" placeholder="Enter degree" required
                        onChange={(e) => setContent({ ...content, degree: e.target.value })}
                />
                <div className={styles.row}>
                    <div className={styles.col}>
                        <label htmlFor="startDate">Start Date</label>
                        <DatePicker id="startDate" placeholder="Select start date" picker='month'
                            onChange={(_, dateString) => setContent({ ...content, startDate: dateString })}
                        />
                    </div>
                    <div className={styles.col}>
                        <label htmlFor="endDate">End Date</label>
                        <DatePicker id="endDate" placeholder="Select end date" picker='month' disabled={content.current}
                            onChange={(_, dateString) => setContent({ ...content, endDate: dateString })}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <Checkbox id="current" checked={content.current} 
                        onChange={(e) => setContent({ ...content, current: e.target.checked })} 
                    >
                        Not yer graduated
                    </Checkbox>
                    <label htmlFor="result">Result</label>
                    <input type="text" id="result" placeholder="Enter result" required
                            onChange={(e) => setContent({ ...content, result: e.target.value })}
                    />
                </div>
            </div>
        ),
        experience: (
            <div className={styles.inputForm}>
                <label htmlFor="job-title">Job Title</label>
                <input type="text" id="job-title" placeholder="Enter Job Title" 
                        onChange={(e) => setContent({ ...content, position: e.target.value })} 
                />
                <label htmlFor="company">Company</label>
                <input type="text" id="company" placeholder="Enter Company Name" 
                        onChange={(e) => setContent({ ...content, company: e.target.value })}
                />
                <div className={styles.row}>
                    <div className={styles.col}>
                        <label htmlFor="startDate">Start Date</label>
                        <DatePicker id="startDate" placeholder="Select start date" picker='month'
                            onChange={(date, dateString) => setContent({ ...content, startDate: dateString })}
                        />
                    </div>
                    <div className={styles.col}>
                        <label htmlFor="endDate">End Date</label>
                        <DatePicker id="endDate" placeholder="Select end date" picker='month' disabled={content.current}
                            onChange={(date, dateString) => setContent({ ...content, endDate: dateString })}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <Checkbox id="current" checked={content.current} 
                        onChange={(e) => setContent({ ...content, current: e.target.checked })} 
                    >
                        Still Working
                    </Checkbox>
                    <label htmlFor="location">Location</label>
                    <input type="text" id="location" placeholder="Enter location"
                            onChange={(e) => setContent({ ...content, location: e.target.value })}
                    />
                </div>
                <label htmlFor="description">Description</label>
                <textarea id="description" placeholder="Enter description" rows={4}
                        onChange={(e) => setContent({ ...content, description: e.target.value })}
                />
            </div>
        ),
        projects: (
            <div className={styles.inputForm}>
                <label htmlFor="project-name">Project Name</label>
                <input type="text" id="project-name" placeholder="Enter Project Name" 
                        onChange={(e) => setContent({ ...content, name: e.target.value })} 
                />
                <label htmlFor="techstack">Tech Stack</label>
                <input type="text" id="techstack" placeholder="Enter Tech Stack" 
                        onChange={(e) => setContent({ ...content, techstack: e.target.value })}
                />
                <div className={styles.row}>
                    <div className={styles.col}>
                        <label htmlFor="startDate">Start Date</label>
                        <DatePicker id="startDate" placeholder="Select start date" picker='month'
                            onChange={(date, dateString) => setContent({ ...content, startDate: dateString })}
                        />
                    </div>
                    <div className={styles.col}>
                        <label htmlFor="endDate">End Date</label>
                        <DatePicker id="endDate" placeholder="Select end date" picker='month' disabled={content.current}
                            onChange={(date, dateString) => setContent({ ...content, endDate: dateString })}
                        />
                    </div>
                </div>
                <Checkbox id="current" checked={content.current} 
                        onChange={(e) => setContent({ ...content, current: e.target.checked })} 
                    >
                    Still Working
                </Checkbox>
                <label htmlFor="description">Description</label>
                <textarea id="description" placeholder="Enter description" rows={4}
                        onChange={(e) => setContent({ ...content, description: e.target.value })}
                />
            </div>
        ),
        skills: (
            <div className={styles.inputForm}>
                <label htmlFor="category">Category</label>
                <input type="text" id="category" placeholder="Enter category" 
                        onChange={(e) => setContent({ ...content, category: e.target.value })} 
                />
                <label htmlFor="skills">Skills</label>
                <div className={styles.skills} id='skills'>
                    {
                        content.items.map((item, index) => (
                            <div key={index} className={styles.skillContainer}>
                                <div key={index} className={styles.skill}>{item}</div>
                                <Button type="text" className={styles.removeButton}
                                    onClick={() => {
                                        const newItems = content.items.filter((_, i) => i !== index);
                                        setContent({ ...content, items: newItems });
                                    }}
                                >
                                    X
                                </Button>
                            </div>
                        ))
                    }
                </div>
                <label htmlFor="add-skill">Add Skills</label>
                <input type="text" id="add-skill" placeholder="Enter skills" 
                    value={content.currentItem}
                    onChange={(e) => setContent({ ...content, currentItem: e.target.value })}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && content.currentItem !== "") {
                            setContent({ ...content, items: [...content.items, content.currentItem], currentItem: "" });
                        }
                    }}
                />
                <p>Press Enter to add skill</p>
            </div>
        ),
        courses: (
            <div className={styles.inputForm}>
                <label htmlFor="courses">Courses</label>
                <div className={styles.courses} id='courses'>
                    {
                        content.items.map((item, index) => ( 
                            <div key={index} className={styles.courseContainer}>
                                <div key={index} className={styles.course}>{item}</div>
                                <Button type="text" className={styles.removeButton}
                                    onClick={() => {
                                        const newItems = content.items.filter((_, i) => i !== index);
                                        setContent({ ...content, items: newItems });    
                                    }}
                                >
                                    X
                                </Button>
                            </div>
                        ))
                    }
                </div>
                <label htmlFor="course-name">Add Course</label>
                <input type="text" id="course-name" placeholder="Enter Course Name" 
                value={content.currentItem}
                        onChange={(e) => setContent({ ...content, currentItem: e.target.value })}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && content.currentItem !== "") {
                                setContent({ ...content, items: [...content.items, content.currentItem], currentItem: "" });
                            }
                        }} 
                />
            </div>
        ),
        achievements: (
            <div className={styles.inputForm}>
                <label htmlFor="achievements">Achievements</label>
                <div className={styles.achievements} id='achievements'>
                    {
                        content.items.map((item, index) => (
                            <div key={index} className={styles.achievementContainer}>
                                <div key={index} className={styles.achievement}>{item}</div>
                                <Button type="text" className={styles.removeButton}
                                    onClick={() => {
                                        const newItems = content.items.filter((_, i) => i !== index);
                                        setContent({ ...content, items: newItems });
                                    }}
                                >
                                    X
                                </Button>
                            </div>
                        ))
                    }
                </div>
                <label htmlFor="achievement-name">Add Achievement</label>
                <input type="text" id="achievement-name" placeholder="Enter Achievement Name" 
                    value={content.currentItem}
                    onChange={(e) => setContent({ ...content, currentItem: e.target.value })}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && content.currentItem !== "") {
                            setContent({ ...content, items: [...content.items, content.currentItem], currentItem: "" });
                        }
                    }} 
                />
            </div>
        ),
        basicInfo: (
            <div className={styles.inputForm}>
                <div className={styles.row}>
                    <div className={styles.col}>
                        <label htmlFor="name">Name</label>
                        <input type="text" id="name" placeholder="Enter name" value={content.name} required
                                onChange={(e) => setContent({ ...content, name: e.target.value })} 
                        />
                    </div>
                    <div className={styles.col}>
                        <label htmlFor="email">Email</label>
                        <input type="text" id="email" placeholder="Enter email" value={content.email} required
                                onChange={(e) => setContent({ ...content, email: e.target.value })}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.col}>
                        <label htmlFor="phone">Phone</label>
                        <input type="text" id="phone" placeholder="Enter phone number" value={content.phone} required
                                onChange={(e) => setContent({ ...content, phone: e.target.value })}
                        />
                    </div>
                    <div className={styles.col}>
                        <label htmlFor="address">Address</label>
                        <input type="text" id="address" placeholder="Enter address" value={content.address} required
                                onChange={(e) => setContent({ ...content, address: e.target.value })}
                        />
                    </div>
                </div>
                <label htmlFor="links">Links</label>
                <div className={styles.links} id='links'>
                    {
                        content.links.map((link, index) => (
                            <div key={index} className={styles.linkContainer}>
                                <div key={index} className={styles.link}>
                                    {linkIcon[linkType(link)]}
                                    {link}
                                </div>
                                <Button type="text" className={styles.removeButton}
                                    onClick={() => {
                                        const newLinks = content.links.filter((_, i) => i !== index);
                                        setContent({ ...content, links: newLinks });
                                    }}
                                >
                                    X
                                </Button>
                            </div>
                        ))
                    }
                </div>
                <label htmlFor="add-link">Add Link</label>
                <input type="text" id="add-link" placeholder="Enter link"
                    value={content.currentLink}
                    onChange={(e) => setContent({ ...content, currentLink: e.target.value })}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && content.currentLink !== "") {
                            setContent({ ...content, links: [...content.links, content.currentLink], currentLink: "" });
                        }
                    }}
                />
                <label htmlFor='languages'>Languages</label>
                <div className={styles.languages} id='languages'>
                    {
                        content.languages.map((language, index) => (
                            <div key={index} className={styles.languageContainer}>
                                <div key={index} className={styles.language}>{language}</div>
                                <Button type="text" className={styles.removeButton}
                                    onClick={() => {
                                        const newLanguages = content.languages.filter((_, i) => i !== index);
                                        setContent({ ...content, languages: newLanguages });
                                    }}
                                >
                                    X
                                </Button>
                            </div>
                        ))
                    }
                </div>
                <label htmlFor="add-language">Add Language</label>
                <input type="text" id="add-language" placeholder="Enter language"
                    value={content.currentLanguage}
                    onChange={(e) => setContent({ ...content, currentLanguage: e.target.value })}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && content.currentLanguage !== "") {
                            setContent({ ...content, languages: [...content.languages, content.currentLanguage], currentLanguage: "" });
                        }
                    }}
                />
            </div>
        ),
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if(section === "basicInfo") {
            setContent({
                ...content,
                name: profile.name,
                email: profile.email,
                phone: profile.phone,
                address: profile.address,
                links: profile.links,
                languages: profile.languages,
            });
        }
    }, [section]);

    useEffect(() => {
        if (!props.user?.userData?._id) return;

        const fetchProfiile = async () => {
            axios.post(`${SERVER_ROUTE}/api/profile/getProfile`, {
                userId: props.user?.userData?._id
            }, { withCredentials: true }).then((response) => {
                if (response.data.success) {
                    setProfile(response.data.profile);
                } else {
                    alert("Failed to fetch profile data");
                }
            }).catch((error) => {
                console.log(error);
                console.error("Error fetching profile data:", error);
            });
        }
        fetchProfiile();
    }, [props.user.userData]);

  const { Content, Header, Sider } = Layout;
  const profileSections = ['education', 'skills', 'experience', 'projects', 'courses', 'achievements', 'por'];
  return (
    <>
    <Layout hasSider className={styles.layout} style={{height: '92vh'}}>
        <Sider style={siderStyle} width={300}>
            <div className={styles.profile}>
                <div className={styles.profilePictureContainer}>
                    <User className={styles.profilePicture}/>
                </div>
                <div className={styles.profileDetails}>
                    <div className={styles.name}>
                        {profile.name}
                    </div>
                    <div className={styles.email}>
                        <MailOutlined className={styles.icon}/>
                        {profile.email}
                    </div>
                    <div className={styles.phone}>
                        <PhoneOutlined className={styles.icon}/>
                        {profile.phone}
                    </div>
                    <div className={styles.address}>
                        <HomeOutlined className={styles.icon}/>
                        {profile.address}
                    </div>
                </div>
                <h3>Links</h3>
                <div className={styles.links}>
                    {
                        profile.links.map((link, index) => (
                            <div key={index} className={styles.link}>
                                {linkIcon[linkType(link)]}
                                <a href={link} target="_blank" rel="noopener noreferrer">{getUserName(link)}</a>
                            </div>
                        ))
                    }
                </div>
                <h3>Languages</h3>
                <div className={styles.languages}>
                    {
                        profile.languages.map((language, index) => (
                            <div key={index} className={styles.language}>
                                {language}
                            </div>
                        ))
                    }
                </div>
                <Button type="primary" className={styles.editButton}
                    onClick={() => handleAddItem('basicInfo')}
                >
                    Edit Profile
                </Button>
            </div>
        </Sider>
        <Layout>
            <Header className={styles.header}>
                <div className={styles.navbar}>
                    {profileSections.map((section, index) => (
                        <a key={index} href={`#${section}`} className={styles.navLink}>
                            {section.charAt(0).toUpperCase() + section.slice(1)}
                        </a>
                    ))}
                </div>
            </Header>
            <Content style={{overflow: 'initial' }}>
                <div className={styles.main}>
                    <div className={styles.section} id='education'>
                        <div className={styles.sectionHeader}>
                            <h2>Education</h2>  
                            <Button type="primary" className={styles.addButton}
                                onClick={() => handleAddItem('education')}
                            >
                                Add New
                            </Button>
                        </div>
                        <div className={styles.content}>
                            {
                                profile.education.map((edu, index) => (
                                    editIndex !== `edu-${index}` ?
                                    <div key={index} className={styles.item}>
                                        <div className={styles.data}>
                                            <div className={styles.title}>
                                                <h3>{edu.college}</h3>
                                                <div className={styles.date}>
                                                    {edu.startDate} - {edu.current ? "Present" : edu.endDate}
                                                </div>
                                            </div>
                                            <div className={styles.subTitle}>
                                                <h4>{edu.degree}</h4>
                                                <div className={styles.result}>{edu.result}</div>
                                            </div>
                                        </div>
                                        <div className={styles.actions}>
                                            <EditFilled onClick={() => {
                                                setEditIndex(`edu-${index}`);
                                                setSection('education');
                                                setContent({
                                                    ...content,
                                                    college: edu.college,
                                                    degree: edu.degree,
                                                    startDate: edu.startDate,
                                                    endDate: edu.endDate,
                                                    result: edu.result,
                                                    current: edu.current,
                                                })
                                            }
                                            }/>
                                            <DeleteFilled onClick={() => handleDelete('education', index)}/>
                                        </div>
                                    </div> :
                                    <div key={index} className={styles.item} style={{gap: '10px'}}>
                                        <div className={styles.data}>
                                            <div className={styles.title}>
                                                <div className={styles.col}>
                                                    <label htmlFor="college">College</label>
                                                    <input type='text' id='college' value={content.college}
                                                    onChange={(e) => setContent({
                                                        ...content, college: e.target.value
                                                    })}/>
                                                </div>
                                                <div style={{display: 'flex', gap: '10px', width: 'fit-content'}}>
                                                    <div className={styles.col}>
                                                        <label htmlFor="startDate">Start Date</label>
                                                        <DatePicker id="startDate" placeholder="Select start date" picker='month'
                                                            value={content.startDate ? dayjs(content.startDate, 'YYYY-MM') : null} 
                                                            onChange={(_, dateString) => setContent({ ...content, startDate: dateString })}
                                                        />
                                                    </div>
                                                    <div className={styles.col}>
                                                        <label htmlFor="endDate">End Date</label>
                                                        <DatePicker id="endDate" placeholder="Select end date" picker='month' disabled={content.current}
                                                            value={content.current ? null : content.endDate ?  dayjs(content.endDate, 'YYYY-MM') : null}
                                                            onChange={(_, dateString) => setContent({ ...content, endDate: dateString })}
                                                        />
                                                    </div>
                                                    <Checkbox id="current" checked={content.current} className={styles.checkbox}
                                                        onChange={(e) => setContent({ ...content, current: e.target.checked })}
                                                    >
                                                        Not yet graduated
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className={styles.subTitle}>
                                                <div className={styles.col}>
                                                    <label htmlFor="degree">Degree</label>
                                                    <input type='text' id='degree' value={content.degree}
                                                    onChange={(e) => setContent({
                                                        ...content, degree: e.target.value
                                                    })}/>
                                                </div>
                                                <div className={styles.col}>
                                                    <label htmlFor="result">Result</label>
                                                    <input type='text' id='result' value={content.result}
                                                    onChange={(e) => setContent({
                                                        ...content, result: e.target.value
                                                    })}/>
                                                </div>
                                            </div>
                                            <div>
                                                <Button type='text' 
                                                    onClick={() => handleSave('education', index)}
                                                    loading={confirmLoading}
                                                >
                                                    Save
                                                </Button>
                                                <Button type='text' 
                                                    onClick={() => {
                                                        setEditIndex('');
                                                        setContent(formContent);
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className={styles.section} id='skills'>
                        <div className={styles.sectionHeader}>
                            <h2>Skills</h2>  
                            <Button type="primary" className={styles.addButton}
                                onClick={() => handleAddItem('skills')}
                            >
                                Add New
                            </Button>
                        </div>
                        <div className={styles.content}>   
                            {
                                profile.skills.map((skill, index) => (
                                    editIndex !== `skill-${index}` ?
                                    <div key={index} className={styles.item}>
                                        <div className={styles.data}>                                       
                                            <h3>{skill.category}</h3>
                                            <div className={styles.skills}>
                                                {
                                                    skill.items.map((item, index) => (
                                                        <div key={index} className={styles.skill}>{item}</div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        <div className={styles.actions}>
                                            <EditFilled onClick={() => {
                                                setEditIndex(`skill-${index}`);
                                                setSection('skills');
                                                setContent({
                                                    ...content,
                                                    category: skill.category,
                                                    items: skill.items,
                                                })
                                            }}
                                            />
                                            <DeleteFilled onClick={() => handleDelete('skills', index)}/>
                                        </div>
                                    </div> :
                                    <div key={index} className={styles.item} style={{gap: '10px'}}>
                                        <div className={styles.data}>
                                            <div className={styles.title}>
                                                <div className={styles.col}>
                                                    <label htmlFor="category">Category</label>
                                                    <input type='text' id='category' value={content.category}
                                                    onChange={(e) => setContent({
                                                        ...content, category: e.target.value
                                                    })}/>
                                                </div>
                                            </div>
                                            <div className={styles.col}>
                                                <label htmlFor="skills">Skills</label>
                                                <div className={styles.skills} id='skills'>
                                                    {
                                                        content.items.map((item, index) => (
                                                            <div key={index} className={styles.skillContainer}>
                                                                <input type='text' className={styles.skill} value={item}
                                                                    placeholder='Enter skill'
                                                                    onChange={(e) => {
                                                                        const newItems = [...content.items];
                                                                        newItems[index] = e.target.value;
                                                                        setContent({ ...content, items: newItems });
                                                                    }}
                                                                />
                                                                <Button type="text" className={styles.removeButton}
                                                                    onClick={() => {
                                                                        const newItems = content.items.filter((_, i) => i !== index);
                                                                        setContent({ ...content, items: newItems });
                                                                    }}
                                                                >
                                                                    X
                                                                </Button>
                                                            </div>
                                                        ))
                                                    }
                                                    <Button type="text"
                                                        onClick={() => {
                                                            setContent({ ...content, items: [...content.items, content.currentItem], currentItem: "" });
                                                        }}
                                                    >
                                                        New
                                                    </Button>
                                                </div>
                                            </div>
                                            <div>
                                                <Button type='text'
                                                    onClick={() => handleSave('skills', index)}
                                                    loading={confirmLoading}
                                                >
                                                    Save
                                                </Button>
                                                <Button type='text' 
                                                    onClick={() => {
                                                        setEditIndex('');
                                                        setContent(formContent);
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }  
                        </div>
                    </div>
                    <div className={styles.section} id='experience'>
                    <div className={styles.sectionHeader}>
                            <h2>Experience</h2>  
                            <Button type="primary" className={styles.addButton}
                                onClick={() => handleAddItem('experience')}
                            >
                                Add New
                            </Button>
                        </div>
                        <div className={styles.content}>
                            {
                                profile.experience.map((exp, index) => (
                                    editIndex !== `exp-${index}` ?
                                    <div key={index} className={styles.item}>
                                        <div className={styles.data}>
                                            <div className={styles.title}>
                                                <h3>{exp.position}</h3>
                                                <div className={styles.date}>
                                                    {exp.startDate} - {exp.current ? "Present" : exp.endDate}
                                                </div>
                                            </div>
                                            <div className={styles.subTitle}>
                                                <h4>{exp.company}</h4>
                                                <div className={styles.location}>{exp.location}</div>
                                            </div>
                                            <div className={styles.description}>
                                                {exp.description}
                                            </div>
                                        </div>
                                        <div className={styles.actions}>
                                            <EditFilled onClick={() => {
                                                setEditIndex(`exp-${index}`);
                                                setSection('experience');
                                                setContent({
                                                    ...content,
                                                    position: exp.position,
                                                    company: exp.company,
                                                    startDate: exp.startDate,
                                                    endDate: exp.endDate,
                                                    location: exp.location,
                                                    description: exp.description,
                                                    current: exp.current,
                                                })
                                            }
                                            }/>
                                            <DeleteFilled onClick={() => handleDelete('experience', index)}/>
                                        </div>
                                    </div> :
                                    <div key={index} className={styles.item} style={{gap: '10px'}}>
                                        <div className={styles.data}>
                                            <div className={styles.title}>
                                                <div className={styles.col}>
                                                    <label htmlFor="job-title">Job Title</label>
                                                    <input type='text' id='job-title' value={content.position}
                                                    onChange={(e) => setContent({
                                                        ...content, position: e.target.value
                                                    })}/>
                                                </div>
                                                <div style={{display: 'flex', gap: '10px', width: 'fit-content'}}>
                                                    <div className={styles.col}>
                                                        <label htmlFor="startDate">Start Date</label>
                                                        <DatePicker id="startDate" placeholder="Select start date" picker='month'
                                                            value={content.startDate ? dayjs(content.startDate, 'YYYY-MM') : null} 
                                                            onChange={(_, dateString) => setContent({ ...content, startDate: dateString })}
                                                        />
                                                    </div>
                                                    <div className={styles.col}>
                                                        <label htmlFor="endDate">End Date</label>
                                                        <DatePicker id="endDate" placeholder="Select end date" picker='month' disabled={content.current}
                                                            value={content.current ? null : content.endDate ?  dayjs(content.endDate, 'YYYY-MM') : null}
                                                            onChange={(_, dateString) => setContent({ ...content, endDate: dateString })}
                                                        />
                                                    </div>
                                                    <Checkbox id="current" checked={content.current} className={styles.checkbox}
                                                        onChange={(e) => setContent({ ...content, current: e.target.checked })}
                                                    >
                                                        Still Working
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className={styles.subTitle}>
                                                <div className={styles.col}>
                                                    <label htmlFor="company">Company</label>
                                                    <input type='text' id='company' value={content.company}
                                                    onChange={(e) => setContent({
                                                        ...content, company: e.target.value
                                                    })}/>
                                                </div>
                                                <div className={styles.col}>
                                                    <label htmlFor="location">Location</label>
                                                    <input type='text' id='location' value={content.location}
                                                    onChange={(e) => setContent({
                                                        ...content, location: e.target.value
                                                    })}/>
                                                </div>
                                            </div> 
                                            <label htmlFor="description">Description</label>
                                            <textarea id="description" placeholder="Enter description" rows={4}
                                                value={content.description}
                                                onChange={(e) => setContent({ ...content, description: e.target.value })}
                                            />
                                            <div>
                                                <Button type='text' 
                                                    onClick={() => handleSave('experience', index)}
                                                    loading={confirmLoading}
                                                >
                                                    Save
                                                </Button>
                                                <Button type='text' 
                                                    onClick={() => {
                                                        setEditIndex('');
                                                        setContent(formContent);
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div> 
                                ))
                            }
                        </div>
                    </div>
                    <div className={styles.section} id='projects'>
                        <div className={styles.sectionHeader}>
                            <h2>Projects</h2>  
                            <Button type="primary" className={styles.addButton}
                                onClick={() => handleAddItem('projects')}
                            >
                                Add New
                            </Button>
                        </div>
                        <div className={styles.content}>
                            {
                                profile.projects.map((project, index) => (
                                    editIndex !== `proj-${index}` ?
                                    <div key={index} className={styles.item}>
                                        <div className={styles.data}>
                                            <div className={styles.title}>
                                                <h3>{project.name}</h3>
                                                <div className={styles.date}>
                                                    {project.startDate} - {project.current ? "Present" : project.endDate}
                                                </div>
                                            </div>
                                            <div className={styles.subTitle}>
                                                <h4>{project.techstack}</h4>
                                            </div>
                                            <div className={styles.description}>
                                                {project.description}
                                            </div>
                                        </div>
                                        <div className={styles.actions}>
                                            <EditFilled onClick={() => {
                                                setEditIndex(`proj-${index}`);
                                                setSection('projects');
                                                setContent({
                                                    ...content,
                                                    name: project.name,
                                                    techstack: project.techstack,
                                                    startDate: project.startDate,
                                                    endDate: project.endDate,
                                                    description: project.description,
                                                    current: project.current,
                                                })
                                            }
                                            }/>
                                            <DeleteFilled onClick={() => handleDelete('projects', index)}/>
                                        </div>
                                    </div> :
                                    <div key={index} className={styles.item} style={{gap: '10px'}}>
                                        <div className={styles.data}>
                                            <div className={styles.title}>
                                                <div className={styles.col} style={{width: '50%'}}>
                                                    <label htmlFor="project-name">Project Name</label>
                                                    <input type='text' id='project-name' value={content.name}
                                                    style={{width: '100%'}}
                                                    onChange={(e) => setContent({
                                                        ...content, name: e.target.value
                                                    })}/>
                                                </div>
                                                <div style={{display: 'flex', gap: '10px', width: 'fit-content'}}>
                                                    <div className={styles.col} style={{width: 'fit-content'}}>
                                                        <label htmlFor="startDate">Start Date</label>
                                                        <DatePicker id="startDate" placeholder="Select start date" picker='month'
                                                            value={content.startDate ? dayjs(content.startDate, 'YYYY-MM') : null} 
                                                            onChange={(_, dateString) => setContent({ ...content, startDate: dateString })}
                                                        />
                                                    </div>
                                                    <div className={styles.col}>
                                                        <label htmlFor="endDate">End Date</label>
                                                        <DatePicker id="endDate" placeholder="Select end date" picker='month' disabled={content.current}
                                                            value={content.current ? null : content.endDate ?  dayjs(content.endDate, 'YYYY-MM') : null}
                                                            onChange={(_, dateString) => setContent({ ...content, endDate: dateString })}
                                                        />
                                                    </div>
                                                    <Checkbox id="current" checked={content.current} className={styles.checkbox}
                                                        onChange={(e) => setContent({ ...content, current: e.target.checked })}
                                                    >
                                                        Still Working
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className={styles.subTitle}>
                                                <div className={styles.col} style={{width: '100%'}}>
                                                    <label htmlFor="techstack">Tech Stack</label>
                                                    <input type='text' id='techstack' value={content.techstack}
                                                    style={{width: '100%'}}
                                                    onChange={(e) => setContent({
                                                        ...content, techstack: e.target.value
                                                    })}/>
                                                </div>
                                            </div> 
                                            <label htmlFor="description">Description</label>
                                            <textarea id="description" placeholder="Enter description" rows={4}
                                                value={content.description}
                                                onChange={(e) => setContent({ ...content, description: e.target.value })}
                                            />
                                            <div>
                                                <Button type='text' 
                                                    onClick={() => handleSave('projects', index)}
                                                    loading={confirmLoading}
                                                >
                                                    Save
                                                </Button>
                                                <Button type='text' 
                                                    onClick={() => {
                                                        setEditIndex('');
                                                        setContent(formContent);
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className={styles.section} id='courses'>
                        <div className={styles.sectionHeader}>
                            <h2>Courses</h2> 
                            <div style={{display: 'flex', gap: '10px', width: 'fit-content'}}>
                                <Button type="primary" className={styles.addButton}
                                    onClick={() => {
                                        setEditIndex('courses');
                                        setSection('courses');
                                        setContent({
                                            ...content,
                                            items: profile.courses,
                                        })
                                    }}
                                >
                                    Edit
                                </Button>
                                <Button type="primary" className={styles.addButton}
                                    onClick={() => handleAddItem('courses')}
                                >
                                    Add New
                                </Button>
                            </div> 
                        </div>
                        <div className={styles.courses}>
                            {
                                editIndex !== 'courses' ?
                                profile.courses.map((course, index) => (
                                    <div key={index} className={styles.course}>
                                        {course}
                                    </div>
                                )) :
                                <>
                                    {content.items.map((course, index) => (
                                        <div key={index} className={styles.courseContainer}>
                                            <input type='text' value={course} className={styles.course}
                                            style={{width: '100%'}}
                                                onChange={(e) => {
                                                    const newCourses = [...content.items];
                                                    newCourses[index] = e.target.value;
                                                    setContent({ ...content, items: newCourses });
                                                }}
                                            />
                                            <Button type="text" className={styles.removeButton}
                                                onClick={() => {
                                                    const newCourses = content.items.filter((_, i) => i !== index);
                                                    setContent({ ...content, items: newCourses });
                                                }}
                                            >
                                                X
                                            </Button>
                                        </div>
                                    ))}
                                    <Button type="text" className={styles.addButton}
                                        onClick={() => {
                                            setContent({ ...content, items: [...content.items, ""]});
                                        }}
                                    >
                                        New 
                                    </Button>
                                </>
                            }
                        </div>
                        {editIndex === 'courses' &&
                        <div>
                            <Button type='text' 
                                onClick={() => handleSave('courses', 0)}
                                loading={confirmLoading}
                            >
                                Save
                            </Button>
                            <Button type='text' 
                                onClick={() => {
                                    setEditIndex('');
                                    setContent(formContent);
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                        }
                    </div>
                    <div className={styles.section} id='achievements'>
                        <div className={styles.sectionHeader}>
                            <h2>Achievements</h2>  
                            <div style={{display: 'flex', gap: '10px', width: 'fit-content'}}>
                                <Button type="primary" className={styles.addButton}
                                    onClick={() => {
                                        setEditIndex(`achievements`);
                                        setSection('achievements');
                                        setContent({
                                            ...content,
                                            items: profile.achievements,
                                        })
                                    }}
                                >
                                    Edit
                                </Button>
                                <Button type="primary" className={styles.addButton}
                                    onClick={() => handleAddItem('achievements')}
                                >
                                    Add New
                                </Button>
                            </div>
                        </div>
                        <div className={styles.achievements}>
                            {
                                editIndex !== 'achievements' ?
                                profile.achievements.map((achievement, index) => (
                                    <div className={styles.achievement} key={index}>
                                        {achievement}
                                    </div>
                                )) :
                                <>
                                {content.items.map((achievement, index) => (
                                    <div className={styles.achievementContainer} key={index}>
                                        <input type='text' value={achievement} className={styles.achievement}
                                            style={{width: '100%'}}
                                            onChange={(e) => {
                                                const newAchievements = [...content.items];
                                                newAchievements[index] = e.target.value;
                                                setContent({ ...content, items: newAchievements });
                                            }}
                                        />
                                        <Button type="text" className={styles.removeButton}
                                            onClick={() => {
                                                const newAchievements = content.items.filter((_, i) => i !== index);
                                                setContent({ ...content, items: newAchievements });
                                            }}
                                        >
                                            X
                                        </Button>
                                    </div>
                                ))}
                                <Button type="text" className={styles.addButton}
                                    onClick={() => {
                                        setContent({ ...content, items: [...content.items, ""]});
                                    }}
                                >
                                    New
                                </Button>
                                </>
                            }
                        </div>
                        {editIndex === 'achievements' &&
                        <div>
                            <Button type='text' 
                                onClick={() => handleSave('achievements', 0)}
                                loading={confirmLoading}
                            >
                                Save
                            </Button>
                            <Button type='text' 
                                onClick={() => {
                                    setEditIndex('');
                                    setContent(formContent);
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                        }
                    </div>
                </div>
            </Content>
        </Layout>
    </Layout>
    <Modal
        open={open}
        title={content.title[section]}
        onOk={handleOk}
        okText="Save"
        onCancel={handleCancel}
        confirmLoading={confirmLoading}
        maskClosable={false}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            {inputForm[section]}
        </Space>
      </Modal>
    </>
  )
}

export default Profile
